import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { RegisterationAdminDecision, Languages, ServiceStatus, FormMode } from 'src/app/shared/models/enums.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RegistrationAdminDto } from '../../shared/models/registration-admin.model';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { FeesEstimationAdminDto } from '../../shared/models/fees-estimation-admin.model';
import { FeesEstimationAdminService } from '../../shared/services/fees-estimation-admin.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { AgentService } from 'src/app/front-user/services/e-booking/shared/services/agent.service';
import { TranslateService } from '@ngx-translate/core';
import { FeesEstimationRequestComponent } from 'src/app/front-user/services/e-booking/fees-estimation-request/fees-estimation-request.component';
import { first } from 'rxjs/operators';
import { FeesEstimationService } from 'src/app/front-user/services/e-booking/fees-estimation-request/fees-estimation.service';

@Component({
  selector: 'app-measurements-reviewer-decision',
  templateUrl: './measurements-reviewer-decision.component.html',
  styleUrls: ['./measurements-reviewer-decision.component.css']
})
export class MeasurementsReviewerDecisionComponent implements OnInit {
  submitted = false;
  loading = false;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO:  BaseRequest//= new BaseRequest();
  decision = RegisterationAdminDecision;
  decisionKeys = Object.keys(this.decision);
  displayedLang: string;
  decisionValue: number;
  measurementReviewerForm: FormGroup;
  user: User = new User();
  agent: User = new User();
  adminDecisionObject: FeesEstimationAdminDto = new FeesEstimationAdminDto();
  showRequest = false;
  agentId: string;
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  isLoaded: boolean = false;
  isErrorMessage: boolean = false;

  @ViewChild('FeesRequest',{static: false}) FeesRequest: FeesEstimationRequestComponent;
  responseObj: ResponseObject = new ResponseObject();
  lockTaskErrorMessage: boolean = false;
  constructor(private formBuilder: FormBuilder, private baseRequestService: BaseRequestService,
    private globalSrv: GlobalServices,
    private route: ActivatedRoute, private router: Router,
    private translate: TranslateService,
    private FeesEstimationServ: FeesEstimationService,
    private authenticationService: AuthenticationService, private alertService: AlertService,
    private feesSrv: FeesEstimationAdminService, private agentSrv: AgentService) {
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    //this.baseRequestId = this.route.snapshot.params.Id;
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    }else{
      window.history.back();
    }

    this.user = this.globalSrv.user;

  }

  ngOnInit() {

    this.buildForm(null);
  }

  buildForm(decision) {
    this.measurementReviewerForm = this.formBuilder.group({
      Decision: ['', [Validators.required]],
    });
    if (decision == RegisterationAdminDecision.MoreInformation) {
      this.measurementReviewerForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        MoreInformation: ['', [Validators.required]],
      });

    }
  }
  changeDecision(value) {
    this.buildForm(value);
    this.measurementReviewerForm.patchValue({
      Decision: value
    });
    this.decisionValue = value;
  }

  get f() {
    return this.measurementReviewerForm.controls;
  }

  getBaseRequest() {
    this.baseRequestService.getBaseRequest(this.baseRequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        this.requestStatus = this.baseRequestDTO.StatusId;
        this.agentId = this.baseRequestDTO.RequestorId;
        this.isLoaded = true;

        // if (this.requestStatus == ServiceStatus.PendingonMeasurementsOfficerReviewerApproval) {
        //   this.formMode = FormMode.Add;
        //   this.measurementReviewerForm.enable();

        // }
        // else
        if (history.state.data && history.state.data.isCompleted) {
          this.getFeesEstimation();
          this.formMode = FormMode.Readonly;
          this.measurementReviewerForm.disable();
        }
        // else {
        //   this.getFeesEstimation();
        //   this.formMode = FormMode.Readonly;
        //   this.measurementReviewerForm.disable();
        // }
      }
    )
  }

  getFeesEstimation() {

    this.FeesEstimationServ.get(this.baseRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {

        this.responseObj = resObj;
        if (this.responseObj.Success) {
          if (this.responseObj.Data['MoreInformation'] && this.requestStatus == ServiceStatus.PendingonMeasurementsOfficerReviewerApproval) {
            this.decisionValue = RegisterationAdminDecision.MoreInformation;
            this.buildForm(this.decisionValue);
            this.measurementReviewerForm.patchValue({
              Decision: RegisterationAdminDecision.MoreInformation,
              MoreInformation: this.responseObj.Data['MoreInformation']
            });
          }
          else {
            this.decisionValue = RegisterationAdminDecision.Approve;
            this.measurementReviewerForm.patchValue({
              Decision: RegisterationAdminDecision.Approve,
            });
          }

        }
      }

    );
  }
  onSubmit(b) {

    this.submitted = true;
    // stop here if form is invalid
    if (this.measurementReviewerForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.adminDecisionObject = this.measurementReviewerForm.value;
    this.adminDecisionObject.AdminEmail = this.user.UserName;
    this.adminDecisionObject.RequestId = this.baseRequestId;


    this.feesSrv.AddReviewerDecision(this.adminDecisionObject)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            //this.alertService.success('Decision Submitted Successfully', false);
            this.measurementReviewerForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.'+data.ErrorMessages[0]), false);

            this.loading = false;
          }

        });
  }
}
